import { render, staticRenderFns } from "./TemplateQuestionaireFragenModal.vue?vue&type=template&id=630b79c9"
import script from "./TemplateQuestionaireFragenModal.vue?vue&type=script&lang=js"
export * from "./TemplateQuestionaireFragenModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateQuestionaireFragenModal.vue?vue&type=style&index=0&id=630b79c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports